import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRustComponent } from './simple-icons-rust.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRustComponent ],
    exports:      [ SimpleIconsRustComponent ],
    bootstrap:    []
})
export class SimpleIconsRustModule {}
